<template>
  <el-drawer size="800px" v-if="isShow" title="AI智能助手" :visible.sync="draw" :with-header="false"
    :modal-append-to-body="false" @close="closeFn">
    <div class="ai_box">
      <div class="ai_box_header">
        <div class="ai_box_header_introduce">
          <!-- <img
            src="@/assets/images/ai/assistant.png"
            alt=""
            class="ai_box_header_introduce_icon"
          />
          <div class="ai_box_header_introduce_writ">
            <p class="ai_box_header_introduce_writ_top">小云</p>
            <p class="ai_box_header_introduce_writ_bottom">工作台AI智能助手</p>
          </div>
          <div class="ai_box_header_right" @click="changeAi">
            <img src="@/assets/images/ai/copywriting.png" alt="" />
            <span>AI智能文案写作</span>
          </div> -->
          <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/dialogue.png" alt=""
            class="ai_tips_box_icon" />
          <p class="ai_tips_box_prologue">HI，我是云起AI，智能小助手</p>
        </div>
        <i class="el-icon-close ai_box_close" @click="closeFn"></i>
      </div>

      <div ref="messagesContainer" class="messagesContainer" @scroll="handleScroll">
        <!-- 新版UI样式 -->
        <div class="new_ai_tips_box">
          <div class="item_body" v-if="permissions.includes('hide:ai:smart:marketing')">
            <div class="item_title">智能营销</div>
            <div class="item_btn_list">
              <div class="item_btn" @click="newChangeTab(4)">人群策略推荐</div>
              <div class="item_btn" @click="newChangeTab(5)">策略提优</div>
            </div>
            <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/item_img1.png" alt="" />
          </div>
          <div class="item_body" v-if="permissions.includes('hide:ai:smart:marketing')">
            <div class="item_title">数据分析</div>
            <div class="item_btn_list">
              <div class="item_btn" @click="diagnosis">生意诊断</div>
            </div>
            <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/item_img2.png" alt="" />
          </div>
          <div class="item_body">
            <div class="item_title">内容生成</div>
            <div class="item_btn_list">
              <div class="item_btn" @click="changeAi">智能文案写作</div>
            </div>
            <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/item_img3.png" alt="" />
          </div>
          <div class="item_body">
            <div class="item_title">智能助手</div>
            <div class="ai_question_list">
              <div class="ai_question_list_inner">
                <div v-for="(item, index) in questionLists" :key="'original-' + index" class="ai_question_item"
                  @click="changeQuestion(item.recommendQuestion)">
                  <div class="icon">推荐</div>
                  <div class="recommendQuestion">
                    {{ item.recommendQuestion }}
                  </div>
                </div>
                <div v-for="(item, index) in questionLists" :key="'cloned-' + index" class="ai_question_item"
                  @click="changeQuestion(item.recommendQuestion)">
                  <div class="icon">推荐</div>
                  <div class="recommendQuestion">
                    {{ item.recommendQuestion }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="ai_chat_message">
          <chatItem v-for="(message, index) in reversedArray" :key="index + '_old'" :message="message"
            :parent-method="parentMethod" />
          <chatItem v-for="(message, index) in messageLists" :key="index + '_new'" :message="message"
            :parent-method="parentMethod" @changeQs="changeQs" @inputText="inputText"
            @changeQuestion="newChangeQuestion" />
        </div>
      </div>
      <div class="new_dui">
        <div class="new_session" @click="newSession()">
          <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/ai/add.png" alt="" />
          <span>新会话</span>
        </div>
        <div class="ai_robot_input">
          <textarea v-model="question" type="textarea" class="custom_input" placeholder="有什么问题尽管问我~"
            @keydown.enter="handleSend" />
          <div class="ai_robot_input_send">
            <img src="https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/hd/20251126/9d38193b1ba248e684ce3f5d52f7ff2c.png"
              alt="" v-if="!isMessage" @click="handleSend" />
            <img src="https://yunqi-taohd.oss-cn-hangzhou.aliyuncs.com/hd/20251126/a9bf707e16464737a899b06350d04450.png"
              alt="" class="isStop" @click="stopMessage" v-if="isMessage" />
          </div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import chatItem from "./components/chatItem.vue";
import { fetchEventSource } from "@microsoft/fetch-event-source";
import {
  getRecommended,
  toNewChat,
  getMessage,
  getLastChatType,
} from "@/api/ai/index.js";
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    userInfo: {
      type: Object,
      default: {},
    },
  },
  components: {
    chatItem,
  },
  computed: {
    reversedArray() {
      // 确保 oldMessageLists 是一个数组
      const list = Array.isArray(this.oldMessageLists)
        ? this.oldMessageLists
        : [];
      // 创建新数组并反转
      return [...list].reverse();
    },
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    }
  },
  data() {
    return {
      draw: true,
      aiDrawer: true,
      tabType: 1,
      current: 1,
      currentIndex: 1,
      questionLists: [],
      oldLoading: [],
      messageLists: [],
      oldMessageLists: [],
      question: "",
      isMessage: false,
      stopSse: false,
      scrollPosition: {
        height: 0,
        top: 0,
      },
      controller: null,
      displayedText: "",
      dataLists: [],
      messagenew: "",
      autoScrollEnabled: true,
      oldLoading: false,
      isHot: false,
      hotLists: [],
      isCapacity: false,
      capacityLists: [],
      newSse: false,
      isTest: true,
      isObject: false,
      isType: false,
      notList: false,
      newChatId: "",
      newConversationId: "",
      // 历史会话类型
      lastChatType: null,
    };
  },
  watch: {
    isShow(newVal) {
      if (newVal) {
        this.draw = true;
      } else {
        this.draw = false;
      }
    },
    messageLists(newVal) {
      console.log("messageLists监听数据", newVal);
    },
  },
  methods: {
    async getLastChatType() {
      let res = await getLastChatType({
        userId: "JD_" + this.userInfo.platformCompanyUserId,
      });
      console.log(res, "12345");

      if (res.data) {
        this.lastChatType = res.data;
        this.newChangeTab(this.lastChatType == 1 ? 4 : 5, true);
      } else {
        this.getOldMessage();
      }
    },
    async newGetQs(index, isInit) {
      if (this.notList) {
        this.$message.warning("暂无其他预置问题~");
        this.notList = !this.notList;
      }
      if (!index) {
        // 将文案数据抛入
        this.appendMessage({
          role: "user",
          content: this.newTabType == 4 ? "人群策略推荐" : "策略提优",
          source: [],
          status: "finish",
        });
        // 将文案数据抛入
        this.appendMessage({
          role: "assistant",
          content: "",
          source: [],
          status: "loading",
        });
        // 回到底部
        setTimeout(() => {
          this.scrollToBottom();
        }, 300);
      }
      const { data } = await getRecommended({
        userId: "JD_" + this.userInfo.platformCompanyUserId,
        // userId: "TB_123456789",
        type: this.newTabType,
        current: this.newCurrent,
        size: 3,
      });

      if (data.records && data.total <= 3 && this.newCurrent == 1) {
        this.messageQuestionLists = data.records;
        if (!index) {
          // 将文案数据抛入
          this.appendMessage({
            role: "assistant",
            questionData: {
              index: this.messageLists.length,
              data: this.messageQuestionLists,
              textName: this.newTabType == 4 ? "人群策略推荐" : "策略提优",
            },
            source: [],
            status: "finish",
          });
          // 回到底部
          setTimeout(() => {
            this.scrollToBottom();
          }, 300);
        } else {
          this.messageLists[index - 1].questionData.data =
            this.messageQuestionLists;
        }
        this.newCurrent = 0;
        this.notList = true;
        if (isInit) {
          this.getOldMessage();
        }
        return;
      }

      this.messageQuestionLists = data.records;
      if (!index) {
        // 将文案数据抛入
        this.appendMessage({
          role: "assistant",
          questionData: {
            index: this.messageLists.length,
            data: this.messageQuestionLists,
            textName: this.newTabType == 4 ? "人群策略推荐" : "策略提优",
          },
          source: [],
          status: "finish",
        });
        // 回到底部
        setTimeout(() => {
          this.scrollToBottom();
        }, 300);
      } else {
        this.messageLists[index - 1].questionData.data =
          this.messageQuestionLists;
      }
      if (this.newCurrent * 3 >= data.total) {
        this.newCurrent = 0;
        this.notList = true;
      }

      if (isInit) {
        this.getOldMessage();
      }
    },
    async newChangeTab(type, isInit) {
      if (!isInit) {
        const { data } = await toNewChat({
          userId: "JD_" + this.userInfo.platformCompanyUserId,
          type: type == 4 ? 1 : 2,
          // userId: "TB_1234567890",
        });
      }
      if (this.controller) {
        this.controller.abort();
        this.controller = null;
      }
      this.isMessage = false;
      this.notList = false;
      this.newSse = true;
      this.messageLists = [];
      this.oldMessageLists = [];
      this.question = "";
      this.newConversationId = "";
      this.newTabType = type;
      this.newCurrent = 1;
      this.newGetQs(false, isInit);
    },
    inputText(test) {
      this.question = test;
    },
    newChangeQuestion(qs) {
      this.question = qs;
      this.newHandleSend();
    },
    changeQs(e) {
      console.log(e);
      this.newCurrent += 1;
      this.newGetQs(e);
    },
    async newHandleSend() {
      console.log("newSend");
      if (this.isMessage) {
        return;
      }
      if (this.question == "") {
        return;
      }
      this.displayedText = "";
      this.messagenew = "";
      this.dataLists = [];
      this.appendMessage({
        role: "user",
        content: this.question,
        source: [],
        status: "finish",
      });
      setTimeout(() => {
        this.scrollToBottom();
      }, 100);
      this.appendMessage({
        role: "assistant",
        content: "",
        source: [],
        status: "loading",
      });
      this.controller = new AbortController();
      this.newTypeWriter();
    },
    parentMethod(data) {
      // console.log("子组件调用了父组件方法", data);
      let newQs = "";
      for (let i in this.oldMessageLists) {
        if (data == this.oldMessageLists[i].chatId) {
          console.log("con1", i + 1, this.oldMessageLists[i]);
          const nextIndex = Number(i) + 1;
          newQs = this.oldMessageLists[nextIndex].content;
        }
      }
      for (let k in this.messageLists) {
        if (data == this.messageLists[k].chatId) {
          const nextIndex2 = Number(k) - 1;
          newQs = this.messageLists[nextIndex2].content;
        }
      }
      this.changeQuestion(newQs);
    },
    closeFn() {
      this.$emit("update:isShow", !this.isShow);
    },
    changeAi() {
      this.$emit("change-types", 1);
    },
    diagnosis() {
      this.$message.warning("该功能暂未开放，敬请期待");
    },
    changeQuestion(qs) {
      this.question = qs;
      this.handleSend();
    },
    newTypeWriter() {
      this.isMessage = true;
      let obj = {
        userId: "JD_" + this.userInfo.platformCompanyUserId,
        message: this.question,
        type: this.newTabType == 4 ? 1 : 2,
        sellerId: JSON.parse(sessionStorage.getItem("sellerPlatform"))
          ? JSON.parse(sessionStorage.getItem("sellerPlatform")).venderId
          : "",
        sellerNick: JSON.parse(sessionStorage.getItem("sellerPlatform"))
          ? JSON.parse(sessionStorage.getItem("sellerPlatform")).shopTitle
          : "",
        account: JSON.parse(sessionStorage.getItem("sellerPlatform"))
          .platformAccountInfo
          ? JSON.parse(sessionStorage.getItem("sellerPlatform"))
            .platformAccountInfo.loginAccount
          : "",
        category:
          JSON.parse(sessionStorage.getItem("sellerPlatform")).category || "",
      };
      if (this.newConversationId) {
        obj.conversationId = this.newConversationId;
      }
      // 将对象转换为 URL 查询字符串
      const queryString = new URLSearchParams(obj).toString();
      this.question = "";
      let _this = this;
      fetchEventSource(`/ai-api/ai-strategy/send-message?${queryString}`, {
        signal: this.controller.signal,
        openWhenHidden: true,
        method: "GET",
        headers: {
          Accept: "text/event-stream",
        },
        onopen(response) {
          if (response.ok) {
            console.log("SSE连接成功", response);
          } else {
            throw new Error(`SSE连接失败: `, response);
          }
        },
        onmessage(event) {
          //服务返回的数据
          _this.question = "";
          console.log("res数据", event.data);
          let newdata;
          try {
            newdata = JSON.parse(event.data);
          } catch (error) {
            newdata = event.data;
          }

          if (newdata.chatId) {
            _this.newChatId = newdata.chatId;
          }

          if (newdata.conversationId) {
            _this.newConversationId = newdata.conversationId;
          }

          newdata = newdata.answer;

          // 文字处理
          if (
            newdata != "``` json" &&
            !_this.isObject &&
            !_this.isType &&
            _this.isTest
          ) {
            _this.messagenew = _this.messagenew + newdata;
            if (_this.dataLists.length) {
              _this.dataLists[0] += newdata;
            } else {
              _this.dataLists.push(newdata);
            }
          } else {
            _this.isObject = true;
            _this.isTest = false;
          }
          // obj对象处理
          if (_this.isObject && newdata != "``` json" && !_this.isType) {
            if (newdata == "```") {
              _this.isObject = false;
              _this.isType = true;
            } else {
              _this.dataLists.push(JSON.parse(newdata));
            }
          }
          // 最后一条类型处理
          if (_this.isType && newdata != "```") {
            _this.dataLists.push(newdata);
            _this.isType = false;
          }
          _this.appendMessage({
            role: "assistant",
            newDataLists: _this.dataLists,
            dataLists: _this.dataLists,
            messagenew: _this.messagenew,
            chatId: _this.newChatId,
            source: [],
            status: "add",
          });
          if (_this.autoScrollEnabled) {
            _this.$nextTick(() => {
              _this.scrollToBottom();
            });
          }
        },
        onerror(err) {
          // 服务异常
          console.error("SSE错误:", err);
          _this.appendMessage({
            role: "assistant",
            content: "当前请求较多，请稍后再试~",
            source: [],
            status: "finish",
          });
          _this.question = "";
          _this.isMessage = false;
          _this.isTest = true;
          _this.isObject = false;
          _this.isType = false;
          throw event;
        },
        onclose() {
          // 服务关闭
          console.log("SSE连接关闭", _this.dataLists.chatId);
          _this.appendMessage({
            role: "assistant",
            content: _this.dataLists,
            dataLists: _this.dataLists,
            newDataLists: _this.dataLists,
            source: [],
            status: "finish",
            messagenew: _this.messagenew,
            dislikeStatus: false,
            likeStatus: false,
            chatId: _this.newChatId,
          });
          _this.isTest = true;
          _this.isObject = false;
          console.log(_this.isObject, _this.isType, _this.isTest, "结束");
          setTimeout(() => {
            _this.scrollToBottom();
          }, 500);
          _this.isMessage = false;
        },
      });
    },
    async handleSend() {
      if (this.newSse) {
        this.newHandleSend();
        return;
      }
      console.log("send");
      if (this.isMessage) {
        return;
      }
      if (this.question == "") {
        return;
      }
      this.displayedText = "";
      this.messagenew = "";
      this.dataLists = [];
      this.appendMessage({
        role: "user",
        content: this.question,
        source: [],
        status: "finish",
      });
      // if (this.question == "转人工") {
      //   this.appendMessage({
      //     role: "assistant",
      //     content:
      //       "如果是产品能力，价格，会员，使用等问题，请详细描述您的诉求或者遇到的问题哦~<br><br>如果需要添加客服，请扫码添加客服企业微信号~",
      //     source: [],
      //     status: "finish",
      //     contentType: {
      //       value: "text",
      //     },
      //   });
      //   this.question = "";
      //   this.isMessage = false;
      //   setTimeout(() => {
      //     this.scrollToBottom();
      //   }, 100);
      //   return;
      // }
      setTimeout(() => {
        this.scrollToBottom();
      }, 100);
      this.appendMessage({
        role: "assistant",
        content: "",
        source: [],
        status: "loading",
      });
      this.controller = new AbortController();
      this.typeWriter();
    },
    typeWriter() {
      this.isMessage = true;
      let obj = {
        userId: "JD_" + this.userInfo.platformCompanyUserId,
        message: this.question,
        sellerId: JSON.parse(sessionStorage.getItem("sellerPlatform"))
          ? JSON.parse(sessionStorage.getItem("sellerPlatform")).venderId
          : "",
        sellerNick: JSON.parse(sessionStorage.getItem("sellerPlatform"))
          ? JSON.parse(sessionStorage.getItem("sellerPlatform")).shopTitle
          : "",
        account: JSON.parse(sessionStorage.getItem("sellerPlatform"))
          .platformAccountInfo
          ? JSON.parse(sessionStorage.getItem("sellerPlatform"))
            .platformAccountInfo.loginAccount
          : "",
        category:
          JSON.parse(sessionStorage.getItem("sellerPlatform")).category || "",
      };
      // 将对象转换为 URL 查询字符串
      const queryString = new URLSearchParams(obj).toString();
      this.question = "";
      let _this = this;
      fetchEventSource(`/ai-api/ai/sendMessage?${queryString}`, {
        signal: this.controller.signal,
        openWhenHidden: true,
        method: "GET",
        headers: {
          Accept: "text/event-stream",
        },
        onopen(response) {
          if (response.ok) {
            console.log("SSE连接成功", response);
          } else {
            throw new Error(`SSE连接失败: `, response);
          }
        },
        onmessage(event) {
          //服务返回的数据
          _this.question = "";
          console.log("res数据", event);
          _this.dataLists.push(JSON.parse(event.data));
          let newdata = JSON.parse(event.data);
          _this.messagenew = _this.messagenew + newdata.content;
          _this.appendMessage({
            role: "assistant",
            content: _this.dataLists,
            dataLists: _this.dataLists,
            messagenew: _this.messagenew,
            source: [],
            status: "add",
          });
          if (_this.autoScrollEnabled) {
            _this.$nextTick(() => {
              _this.scrollToBottom();
            });
          }
        },
        onerror(err) {
          // 服务异常
          console.error("SSE错误:", err);
          _this.appendMessage({
            role: "assistant",
            content: "当前请求较多，请稍后再试~",
            source: [],
            status: "finish",
          });
          _this.question = "";
          _this.isMessage = false;
          throw event;
        },
        onclose() {
          // 服务关闭
          console.log("SSE连接关闭");
          _this.appendMessage({
            role: "assistant",
            content: _this.dataLists,
            dataLists: _this.dataLists,
            source: [],
            status: "finish",
            messagenew: _this.messagenew,
            dislikeStatus: false,
            likeStatus: false,
            chatId: _this.dataLists[0].chatId,
          });
          setTimeout(() => {
            _this.scrollToBottom();
          }, 100);
          _this.isMessage = false;
        },
      });
    },
    stopMessage() {
      this.controller.abort();
      this.controller = null;
      console.log("SSE终止");
      this.appendMessage({
        role: "assistant",
        content: this.dataLists,
        dataLists: this.dataLists,
        source: [],
        status: "abort",
        messagenew: this.messagenew,
        dislikeStatus: false,
        likeStatus: false,
        chatId:
          this.dataLists && this.dataLists.length > 0
            ? this.dataLists[0].chatId
            : "",
      });
      this.isMessage = false;
      setTimeout(() => {
        this.scrollToBottom();
      }, 10);
    },
    appendMessage(options) {
      const {
        role,
        content = [],
        source = [],
        status = "finish",
        dataLists,
        messagenew,
        dislikeStatus,
        likeStatus,
        chatId,
        // 新增推荐问题列表
        questionData,
        // 新增卡片信息
        newDataLists,
      } = options;
      const message = {
        role,
        status: status,
        source,
        content,
        dataLists,
        messagenew,
        dislikeStatus,
        likeStatus,
        chatId,
        // 新增推荐问题列表
        questionData,
        // 新增卡片信息
        newDataLists,
      };
      if (role === "assistant") {
        if (source.length != 0) {
          message.source = source;
        }
      }
      let len = this.messageLists.length;
      console.log(message, "cks");
      if (
        len &&
        ["loading", "add"].includes(this.messageLists[len - 1].status)
      ) {
        this.messageLists[len - 1] = message;
        this.$set(this.messageLists, len - 1, message);
      } else {
        this.messageLists.push(message);
      }
    },
    // 滚动到底部
    // const messagesContainer = ref<any>(null);
    scrollToBottom() {
      if (this.$refs.messagesContainer) {
        this.$refs.messagesContainer.scrollTo({
          top: this.$refs.messagesContainer.scrollHeight,
          behavior: "smooth",
        });
      }
    },
    scrollToTop() {
      if (this.$refs.aiQuestion) {
        this.$refs.aiQuestion.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },

    // 处理用户滚动事件
    handleScroll() {
      const { scrollTop, clientHeight, scrollHeight } =
        this.$refs.messagesContainer;

      // 添加投影效果逻辑
      if (scrollTop > 0) {
        document.querySelector(".ai_box_header").classList.add("with-shadow");
      } else {
        document
          .querySelector(".ai_box_header")
          .classList.remove("with-shadow");
      }

      if (scrollTop <= 0) {
        console.log("889111111");
        if (!this.oldLoading) {
          this.getOldMessage();
        }
        return;
      }
      this.autoScrollEnabled = scrollTop + clientHeight >= scrollHeight - 50;
    },
    changeTab(type) {
      this.tabType = type;
      this.current = 1;
      this.scrollToTop();
      this.getQs();
    },
    async newSession() {
      const { data } = await toNewChat({
        userId: "JD_" + this.userInfo.platformCompanyUserId,
        // userId: "JD_1234567890",
      });
      if (this.controller) {
        this.controller.abort();
        this.controller = null;
      }
      this.isMessage = false;
      this.newSse = false;
      this.messageLists = [];
      this.oldMessageLists = [];
      this.question = "";
      this.isTest = true;
      this.isObject = false;
      this.isType = false;
      this.newConversationId = "";
    },
    async getQs() {
      const { data } = await getRecommended({
        userId: "JD_" + this.userInfo.platformCompanyUserId,
        // userId: "JD_123456789",
        type: this.tabType,
        current: this.current,
        size: 5,
      });
      // if (data.records && data.records.length == 0 && this.current != 1) {
      //   this.current = 1;
      //   this.getQs();
      // }
      // if (data.records && data.records.length < 5 && data.records.length > 0) {
      //   this.current = 0;
      // }
      this.scrollToTop();
      if (data.records && data.records.length < 5 && this.current == 1) {
        this.questionLists = data.records;
        this.current = 0;
        return;
      }
      if (data.records && this.tabType == 1 && !this.isHot) {
        console.log("cksa1", data.records);
        this.hotLists = this.hotLists.concat(data.records);
        console.log("cbc1", this.hotLists);
        if (data.records.length < 5) {
          this.isHot = true;
        }
      }
      if (data.records && this.tabType == 2 && !this.isCapacity) {
        this.capacityLists = this.capacityLists.concat(data.records);
        console.log("cbc2", this.capacityLists);
        if (data.records.length < 5) {
          this.isCapacity = true;
        }
      }
      // this.questionLists = data.records;
      if (this.tabType == 1) {
        if (this.hotLists.length <= 5) {
          this.questionLists = this.hotLists;
          console.log("ccks", this.questionLists);
        } else {
          const shuffled = [...this.hotLists];
          for (let i = shuffled.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
          }
          this.questionLists = shuffled.slice(0, 5);
        }
      } else {
        if (this.capacityLists.length <= 5) {
          this.questionLists = this.capacityLists;
        } else {
          const shuffled2 = [...this.capacityLists];
          for (let i = shuffled2.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [shuffled2[i], shuffled2[j]] = [shuffled2[j], shuffled2[i]];
          }
          this.questionLists = shuffled2.slice(0, 5);
        }
      }
      // if (this.current >= data.pages) {
      //   this.current = 0;
      // }
    },
    async getOldMessage() {
      this.scrollPosition = {
        height: this.$refs.messagesContainer.scrollHeight,
        top: this.$refs.messagesContainer.scrollTop,
      };
      this.oldLoading = true;
      let putData = {
        userId: "JD_" + this.userInfo.platformCompanyUserId,
        // userId: "JD_1234567",
        current: this.currentIndex,
        size: 10,
      };
      if (this.lastChatType) {
        putData.type = this.lastChatType;
      }
      const { data } = await getMessage(putData);
      // console.log("历史数据", data);
      if (data.records && data.records.length > 0) {
        if (this.currentIndex == 1) {
          this.scrollToBottom();
        }
        if (this.lastChatType) {
          // 翻转data.records顺序
          data.records.reverse();
        }
        const newMessage = data.records.map((item) => {
          let put = {};
          if (!this.lastChatType) {
            put = {
              ...item,
              status: "finish",
              role: item.messageType == "question" ? "user" : "assistant",
              content:
                item.messageType == "question"
                  ? item.content
                  : JSON.parse(item.content),
            };
          } else {
            if (item.messageType == "question") {
              this.appendMessage({
                role: "user",
                content: item.content,
                source: [],
                status: "finish",
              });
            } else {
              let dataList = [item.dataList[0]];
              if (item.dataList.length > 1) {
                if (item.dataList[1]) {
                  dataList.push(JSON.parse(item.dataList[1]));
                  // 在数组最后面放入end[commonReply]
                  dataList.push("end[commonReply]");
                }
              }
              this.appendMessage({
                role: "assistant",
                newDataLists: dataList,
                dataLists: dataList,
                messagenew: item.dataList[0],
                dislikeStatus: false,
                likeStatus: false,
                chatId: item.chatId,
                source: [],
                status: "finish",
              });
            }
          }
          return put;
        });
        this.oldMessageLists = [
          ...this.oldMessageLists,
          ...(!this.lastChatType ? newMessage : []),
        ];
        console.log("oldMessageLists数据", this.oldMessageLists);
        this.currentIndex++;
        // 等待DOM更新后恢复滚动位置
        await this.$nextTick();
        const heightDiff =
          this.$refs.messagesContainer.scrollHeight -
          this.scrollPosition.height;
        this.$refs.messagesContainer.scrollTop =
          this.scrollPosition.top + heightDiff;
      }
      this.oldLoading = false;
      console.log("oldMessageLists", this.oldMessageLists);
    },
    // changeQs() {
    //   this.current += 1;
    //   this.getQs();
    // },
  },
  created() {
    console.log("ccc", this.userInfo.platformCompanyUserId);
    setTimeout(() => {
      this.getQs();
      // this.getOldMessage();
      this.getLastChatType();
    }, 500);
    setTimeout(() => {
      this.scrollToBottom();
    }, 1000);
  },
};
</script>

<style lang="scss" scoped>
.ai_box {
  width: 100%;
  height: 100%;
  background: linear-gradient(#fff 75%, rgba(217, 217, 251, 0.6));
  border-radius: 0px 0px 0px 0px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .ai_box_header {
    width: 800px !important;
    // height: 56px;
    background: #ffffff;
    padding-left: 35px;
    display: flex;
    align-items: center;

    // position: fixed !important;
    // right: 0;
    // top: 0;
    // border-bottom: 1px solid #f0f0f0;
    .ai_box_header_introduce {
      display: flex;
      margin: 12px 0 0px 0;

      // align-items: center;
      .ai_tips_box_icon {
        width: 70px;
        margin-right: 8px;
      }

      .ai_tips_box_prologue {
        font-weight: 600;
        font-size: 20px;
        margin: 10px 0 0 0px;
        color: transparent;
        // -webkit-text-stroke: 1px #399bff; /* 设置边框颜色 */
        background: -webkit-linear-gradient(left, #9a56f1, #4c74fd);
        -webkit-background-clip: text;
        background-clip: text;
      }

      .ai_box_header_introduce_icon {
        width: 23px;
        height: 22px;
        margin-right: 8px;
        display: block;
      }

      .ai_box_header_introduce_writ_top {
        font-weight: 600;
        font-size: 14px;
        color: transparent;
        background: linear-gradient(0deg, #9a56f1 0%, #4c74fd 100%);
        -webkit-background-clip: text;
        background-clip: text;
        margin: 0 !important;
      }

      .ai_box_header_introduce_writ_bottom {
        font-weight: 400;
        font-size: 12px;
        color: #666666;
        margin-top: 5px;
        margin-bottom: 0 !important;
      }

      .ai_box_header_right {
        padding: 7px 8px 7px 10px;
        box-sizing: border-box;
        background: #e6eaff;
        border-radius: 4px 4px 4px 4px;
        display: flex;
        align-items: center;
        margin-left: 20px;
        cursor: pointer;

        img {
          width: 18px;
          display: block;
          height: 18px;
          margin-right: 4px;
        }

        span {
          font-weight: bold;
          font-size: 12px;
          color: #5272fc;
        }
      }
    }

    .ai_box_close {
      font-size: 20px;
      position: absolute;
      right: 20px;
      top: 16px;
      cursor: pointer;
      color: #72767b;
    }
  }

  .ai_box_header.with-shadow {
    box-shadow: 0 2px 8px rgba(168, 168, 168, 0.1);
    transition: box-shadow 0.3s ease;
  }
}

.ai_box {
  width: 100%;
  height: 100%;
  // background: linear-gradient(290deg, #f0f2fe 0%, #ebf3ff 100%);
  border-radius: 0px 0px 0px 0px;

  .ai_box_header {
    width: 100%;
    // height: 56px;
    // background: #ffffff;
    // padding-left: 24px;
    display: flex;
    align-items: center;
    position: relative;

    .ai_box_header_introduce {
      display: flex;
      align-items: center;

      .ai_box_header_introduce_icon {
        width: 23px;
        height: 22px;
        margin-right: 8px;
        display: block;
      }

      .ai_box_header_introduce_writ_top {
        font-weight: 600;
        font-size: 14px;
        color: transparent;
        background: linear-gradient(0deg, #9a56f1 0%, #4c74fd 100%);
        -webkit-background-clip: text;
        background-clip: text;
      }

      .ai_box_header_introduce_writ_bottom {
        font-weight: 400;
        font-size: 12px;
        color: #666666;
      }

      .ai_box_header_right {
        padding: 7px 8px 7px 10px;
        box-sizing: border-box;
        background: #e6eaff;
        border-radius: 4px 4px 4px 4px;
        display: flex;
        align-items: center;
        margin-left: 20px;

        img {
          width: 18px;
          display: block;
          height: 18px;
          margin-right: 4px;
        }

        span {
          font-weight: bold;
          font-size: 12px;
          color: #5272fc;
        }
      }
    }

    .ai_box_close {
      font-size: 16px;
      position: absolute;
      right: 20px;
      top: 16px;
      cursor: pointer;
      color: #cccccc;
    }
  }

  .ai_tips_box {
    width: 740px;
    // max-height: 355px;
    // height: 38vh;
    max-height: 405px;
    display: block;
    margin: 30px auto 0;
    background: linear-gradient(180deg, #ffffff 50%, #ffffff 100%);
    box-shadow: inset 0 0 0 2px #fff;
    /* 内部描边 */
    border-radius: 12px 12px 12px 12px;
    border: 2px solid #ffffff;
    // padding: 0 26px 24px 22px;
    padding-bottom: 5px;
    box-sizing: border-box;

    .ai_tips_box_icon {
      width: 57px;
      height: 62px;
      display: block;
      margin-top: -11px;
    }

    .ai_tips_box_tip {
      font-weight: 400;
      font-size: 12px;
      color: #5f5e7b;
      margin-top: 13px !important;
      margin-left: 22px !important;
    }

    .ai_tips_box_tabchange {
      // width: 100%;
      display: flex;
      height: 26px;
      align-items: center;
      margin-top: 20px;
      margin-left: 22px;
      margin-right: 26px;

      .ai_tips_box_tab {
        display: flex;
        height: 26px;
        flex: 1;

        div {
          height: 26px;
          line-height: 26px;
          font-weight: 400;
          font-size: 12px;
          color: #9a99ac;
          padding: 0 12px;
          border-radius: 4px;
          background: #f6f6fc;
          margin-right: 16px;
          cursor: pointer;
        }

        .tab_active {
          font-weight: 400;
          font-size: 12px;
          color: #4d42f5;
          background: #eaeafe;
        }
      }

      .ai_tips_box_change {
        display: flex;
        height: 26px;
        align-items: center;
        cursor: pointer;

        img {
          width: 18px;
          height: 18px;
          display: block;
        }

        span {
          font-weight: 400;
          font-size: 12px;
          color: #3159ff;
          margin-left: 8px;
          line-height: 26px;
        }
      }
    }

    .ai_question {
      width: 100%;
      margin-top: 24px;
      // max-height: 184px;
      // height: calc(100% - 148px);
      // overflow: hidden;
      // overflow-y: scroll;
      padding-left: 22px;
      padding-right: 26px;

      .ai_question_list {
        width: 100%;
        height: 33px;
        background: #f5f7ff;
        border-radius: 4px 4px 4px 4px;
        margin-bottom: 16px;
        line-height: 33px;
        font-weight: 400;
        font-size: 12px;
        color: #1c1b44;
        padding-left: 24px;
        padding-right: 27px;
        display: flex;
        // align-items: center;
        cursor: pointer;

        .ai_question_arrow {
          font-size: 14px;
          color: #9a99ac;
          margin-top: 9px;
        }
      }
    }
  }

  .new_ai_tips_box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 30px;
    flex-wrap: wrap;

    .item_body {
      width: 362px;
      height: 166px;
      background: #f5f7ff;
      border-radius: 18px 18px 18px 18px;
      position: relative;
      margin-bottom: 16px;
      padding: 20px 16px 0 16px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;

      >img {
        position: absolute;
        width: 100px;
        bottom: 0;
        right: 0;
      }

      .item_title {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 15px;
        margin-bottom: 17px;
        color: #000311;
      }

      .item_btn_list {
        display: flex;

        .item_btn {
          height: 40px;
          background: #ffffff;
          border-radius: 12px 12px 12px 12px;
          padding: 0 10px;
          cursor: pointer;
          font-family: PingFang SC, PingFang SC;
          font-weight: 400;
          font-size: 14px;
          color: #000311;
          margin-right: 8px;
          line-height: 40px;
        }

        .item_btn:hover {
          background: #e6e7f0;
        }
      }

      .ai_question_list {
        flex: 1;
        overflow: hidden;
        position: relative;

        .ai_question_item {
          display: flex;
          align-items: center;
          width: 100%;
          height: 40px;
          background: #ffffff;
          border-radius: 12px 12px 12px 12px;
          padding: 0 14px;
          box-sizing: border-box;
          margin-bottom: 8px;
          cursor: pointer;

          .icon {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #4d42f5;
            width: 28px;
            height: 17px;
            background: #eaeafe;
            border-radius: 2px 2px 2px 2px;
            text-align: center;
            line-height: 17px;
            margin-right: 8px;
          }

          .recommendQuestion {
            flex: 1;
            white-space: nowrap; // 防止文本换行
            overflow: hidden; // 隐藏溢出的文本
            text-overflow: ellipsis; // 显示省略号
            font-weight: 400;
            font-size: 14px;
            color: #000311;
          }
        }

        .ai_question_item:hover {
          background: #e6e7f0;
        }
      }

      .ai_question_list::-webkit-scrollbar {
        width: 0 !important;
      }
    }
  }

  .ai_question_list_inner {
    position: absolute;
    width: 100%;
    animation: scroll-up 10s linear infinite;
    /* 调整动画时间和速度 */
  }

  .ai_question_list:hover .ai_question_list_inner {
    animation-play-state: paused;
  }

  @keyframes scroll-up {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(-50%);
      /* 向上滚动自身高度的一半，因为我们有两份数据 */
    }
  }

  .ai_chat_message {
    width: 740px;
    display: block;
    margin: 20px auto 0;
    // max-height: 266px;
    // height: 28.5vh;
    // background: linear-gradient(135deg, #e4efff 0%, #d7e0ff 100%);
    border-radius: 12px 12px 12px 12px;
    // overflow: hidden;
    // overflow-y: auto;
    padding: 0 0px 20px 0px;
    box-sizing: border-box;
  }

  .new_session {
    width: 90px;
    height: 32px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    align-items: center;
    margin-top: 13px;
    margin-bottom: 13px;
    margin-left: 30px;
    cursor: pointer;
    line-height: 32px;

    img {
      width: 13px;
      height: 13px;
      display: inline-block;
      margin-left: 12px;
    }

    span {
      font-weight: 400;
      font-size: 14px;
      color: #1c1b45;
      margin-left: 4px;
      // height: 28px;
      // line-height: 32px;
    }
  }

  .ai_robot_input {
    width: 740px;
    height: 60px;
    background: #ffffff;
    border-radius: 12px;
    border: 1px solid transparent;
    background: linear-gradient(white, white) padding-box,
      /* 内容背景 */
      linear-gradient(180deg, rgba(49, 89, 255, 0.8), rgba(49, 89, 255, 1)) border-box;
    padding: 0 20px;
    /* 根据需要调整 */
    // margin-left: 30px;
    // margin-top: 16px;
    // padding: 20px 20px 0 20px;
    position: relative;
    margin-bottom: 31px;
    margin-left: 30px;
    display: flex;
    align-items: center;

    .question_input {
      width: 100%;
      border: none;
    }

    .custom_input {
      box-shadow: none;
      resize: none;
      // height: 80% !important;
      border: none;
      flex: 1;
    }

    .custom_input:focus-visible {
      outline: none;
    }

    .ai_robot_input_send {
      width: 50px;
      height: 32px;
      background: #EBE6FE;
      border-radius: 50px 50px 50px 50px;
      // margin: 0 20px;
      margin-left: 20px;
      // position: absolute;
      // top: 34px;
      // bottom: 0;
      // right: 20px;
      // margin: auto;
      display: flex;

      img {
        display: block;
        // margin: 2px auto 0;
        margin-top: 2px;
        margin-left: 13px;
        width: 26px;
        height: 26px;
        cursor: pointer;
      }
    }

    .ai_robot_input_send_active {
      background: #f4f7fa;
    }
  }

  .isStop {
    width: 20px !important;
    height: 20px !important;
    display: block !important;
    margin: 6px auto 0 !important;
  }
}

/* 针对所有滚动条 */
::-webkit-scrollbar {
  width: 5px;
  /* 滚动条宽度 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
  border-radius: 100px;
  background: #f3f3f3;
  /* 轨道背景颜色 */
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  background: #dadeeb;
  /* 滑块颜色 */
  border-radius: 10px;
  /* 滑块圆角 */
}

/* 当滑块被激活（例如鼠标点击）时 */
::-webkit-scrollbar-thumb:hover {
  background: #888888;
  /* 滑块激活时的颜色 */
}

.my-drawer {
  z-index: 6666;
}

/deep/ .v-modal {
  display: none;
}

.messagesContainer {
  // background: red;
  // margin-top: 40px;
  overflow: hidden;
  overflow-y: scroll;
  // height: 77%;
  flex: 1;
  padding: 20px 0;
}

.new_dui {
  // position: fixed;
  // right: 30px;
  // bottom: 31px;
  width: 800px;
  // bottom: 0;
  // right: 0;
  // background: linear-gradient(180deg, rgba(227, 226, 253, 0) 0%, #e3e2fd 100%);
}

::v-deep .el-textarea__inner {
  font-family: "Microsoft YaHei", "Arial", "Helvetica", "sans-serif",
    "font_family" !important;
}
</style>
